<template>
    <div id="login-view">
        <div id="logo"><img src="@/assets/login.png" /></div>

        <form @submit.prevent="onSubmit">
            <div class="form-title">Se connecter</div>
            <div class="form-group">
                <label for="login">Utilisateur</label>
                <input
                    type="text"
                    placeholder="Saisissez votre nom d'utilisateur"
                    v-model.trim="$v.login.$model"
                    name="login"
                    class="stretch form-control"
                    :class="{ 'is-invalid': submitted && $v.login.$error }"
                />
                <div v-if="submitted && !$v.login.required" class="invalid-feedback">
                    Veuillez saisir un nom d'utilisateur
                </div>
            </div>
            <div class="form-group">
                <label for="password">Mot de passe</label>
                <input
                    type="password"
                    placeholder="Saisissez votre mot de passe"
                    v-model.trim="$v.password.$model"
                    name="password"
                    class="stretch form-control"
                    :class="{ 'is-invalid': submitted && $v.password.$error }"
                />
                <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                    Veuillez saisir un mot de passe
                </div>
            </div>
            <div class="form-group">
                <button class="osm-button stretch default" :disabled="loading">
                    <span class="spinner-border spinner-border-sm" v-show="loading"></span>
                    <span>Connexion</span>
                </button>
            </div>
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </form>

        <div id="copyright">
            Développé par
            <a class="colink" href="https://www.geonov.fr/" target="_blank">Geonov</a> sous
            <a href="https://www.gnu.org/licenses/gpl-3.0.html" target="_blank" class="colink"
                >Licence publique générale GNU 3.0</a
            >.
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
// import CustomInput from '@/components/Input';
// import CustomCheckbox from '@/components/Checkbox';
// import CustomButton from '@/components/Button';
import { authenticationService } from '@/services';

export default {
    data() {
        return {
            login: '',
            password: '',
            //remember: localStorage.getItem('osm-remember') || false,
            returnUrl: '',
            submitted: false,
            loading: false,
            error: '',
        };
    },
    validations: {
        login: { required },
        password: { required },
    },
    created() {
        // redirect to home if already logged in
        if (authenticationService.currentUserValue) {
            return this.$router.push('/home');
        }
        // get return url from route parameters or default to '/'
        this.returnUrl = this.$route.query.returnUrl || '/';
    },
    methods: {
        onSubmit() {
            this.submitted = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.loading = true;
            authenticationService.login(this.login, this.password).then(
                () => this.$router.push(this.returnUrl),
                (error) => {
                    this.error = error;
                    this.loading = false;
                },
            );
        },
    },
    components: {
        //CustomInput,
        //CustomCheckbox,
        //CustomButton,
    },
};
</script>

<style lang="scss">
#login-view {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f8;
    width: 100vw;
    height: 100vh;

    .form {
        display: flex;
        flex-direction: column;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        padding-left: 25px;
        padding-right: 25px;
        padding-bottom: 30px;
    }

    #logo {
        padding-bottom: 52px;
    }

    input {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        border-radius: 32px;
        padding: 9px 17px;
        border: 1px solid #9ca5b0;
        color: #2a2a2a;
        outline: none;
        -webkit-transition: all 0.25s ease-in-out;
        transition: all 0.25s ease-in-out;
        font-size: 13px;
        margin-top: 9px;
    }

    form {
        // height: 386px;
        width: 420px;
        border-radius: 5px;
        border-top: 5px solid #6c3e91;
        background-color: #ffffff;
        box-shadow: 0 0 7px 2px rgba(207, 207, 207, 0.5);
        display: flex;
        flex-direction: column;
    }

    .form-control.is-invalid,
    .was-validated .form-control:invalid {
        border-color: #dc3545;
        padding-right: 2.25rem;
        background-repeat: no-repeat;
        background-position: center right calc(2.25rem / 4);
        background-size: calc(2.25rem / 2) calc(2.25rem / 2);
        background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#dc3545' viewBox='-2 -2 7 7'><path stroke='#d9534f' d='M0 0l3 3m0-3L0 3'/><circle r='.5'/><circle cx='3' r='.5'/><circle cy='3' r='.5'/><circle cx='3' cy='3' r='.5'/></svg>");
    }

    .invalid-feedback {
        width: 100%;
        margin-top: 0.25rem;
        font-size: 90%;
        color: #dc3545;
        padding-left: 11px;
    }

    .invalid-tooltip {
        position: absolute;
        top: 100%;
        z-index: 5;
        max-width: 100%;
        padding: 0.25rem 0.5rem;
        margin-top: 0.1rem;
        font-size: 0.875rem;
        line-height: 1.5;
        color: #fff;
        background-color: rgba(220, 53, 69, 0.9);
        border-radius: 0.25rem;
    }

    button {
        max-width: 250px;
        align-self: center;
    }

    .alert {
        position: relative;
        padding: 0.75rem 1.25rem;
        margin-bottom: 1rem;
        border: 1px solid transparent;
        border-radius: 4px;
        align-self: center;
        width: 80%;
        max-width: 300px;
        text-align: center;
    }
    .alert-danger {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
    }

    #copyright {
        margin-top: 20px;
        text-align: center;
        .colink {
            text-decoration: none;
            color: #6c3e91;
        }
    }
}
</style>
